module.exports = __webpack_public_path__ + "static/media/2 greek mythology forearm sleeve black and grey realism .1280x1706.4b90e1d2.webp";